export const roundOffCentsInteger = (value: number): number => {
  return Math.round(value / 100) * 100;
};

export * from "./formatCashAmountWithFrequency";
export * from "./annualizeCashValue";
